// extracted by mini-css-extract-plugin
export default {"wrapper":"ResendConfirmationNotice_wrapper__4K-wP"};